import React from "react";
import HeroSection from "../component/HeroSection";
import CTASection from "../component/CTASection";
import SegmentsSection from "../component/SegmentsSection";
import RibbonSection from "../component/RibbonSection";
import ClientSection from "../component/ClientSection";
import AboutSection from "../component/AboutSection";



const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutSection/>
      <RibbonSection />
      <ClientSection/>
       <SegmentsSection />
      <CTASection />
    </>
  );
};

export default Home;